import { Component, computed, ElementRef, inject, input, signal, ViewChild } from "@angular/core"
import { from } from "rxjs"
import { tap } from "rxjs/operators"
import { IntroSubContent } from "../intro.model"
import { NgOptimizedImage } from "@angular/common"
import { prefersReducedMotionQuery, UiThemeService } from "ui-theme"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    NgOptimizedImage,
  ],
  standalone: true,
  template: `
    <div class="relative max-w-full">
      <img
        [alt]="introLogo().image.altText" 
        height="91.4"
        [ngSrc]="imageSrc()"
        class="max-w-full w-auto h-auto"
        width="500"
        priority=""
      >
      @if (showVideo()) {
        <div class="absolute top-0 left-0">
          <video
            #VideoElement
            [muted]="true"
            autoplay 
            loop 
            playsinline
            class="max-w-full"
          >
            <source 
              [src]="introLogo().video.src" 
              [type]="introLogo().video.type"
            >
          </video>
        </div>
      }
    </div>
  `,
  selector: "e2e-intro-header-logo",
})
export class HeaderLogoComponent {
  private themeService = inject(UiThemeService)
  private storageService = inject(StorageService)

  introLogo = input.required<IntroSubContent>()

  @ViewChild("VideoElement") videoElementRef: ElementRef | undefined

  showVideo = signal(!prefersReducedMotionQuery.matches)

  imageSrc = computed(() =>
    this.themeService.isLightMode()
      ? this.storageService.getFileUrl(this.introLogo().image.srcLightMode)
      : this.storageService.getFileUrl(this.introLogo().image.srcDarkMode),
  )

  constructor() {
    prefersReducedMotionQuery.addEventListener("change", () => {
      this.showVideo.set(!prefersReducedMotionQuery.matches)
    })
  }

  get play$() {
    return from(this.videoElementRef?.nativeElement.play()).pipe(
      tap(() => {
        console.log("started play()")
      }),
    )
  }
}
